import { useEffect } from 'react';

/**
 * アプリの名前とページタイトル。
 *
 * 名前は index.html の <title> / apple-mobile-web-app-title、manifest.json の
 * name / short_name、そして画面内（ナビ・ログイン）と**5か所**に出る。
 * 静的ファイル側はここから読めないので、代わりに src/appInfo.test.js が
 * 全部一致していることを検査する。画面内はこの定数を使うこと。
 */
export const APP_NAME = 'DuelSim';
export const APP_FULL_NAME = 'SynchroTools DuelSim';

/**
 * Godot のブラウザ版（`client/godot` の Web 書き出し。CI の deploy-godot-web が同じ S3 の `godot/` に置く）。
 * 同じ出どころなので、ログイン（localStorage の access_token）は Godot の側がそのまま読む。SPA の外のページなので普通のリンクで開く。
 */
export const GODOT_APP_URL = '/godot/index.html';

/**
 * Godot の Android 版（配信受信版の APK。CI の deploy-godot-android が同じ S3 の `godot-android/Synchro.apk` にいつも最新を置く。Issue #884）。
 * デバッグの鍵で署名したもの＝端末で「提供元不明のアプリ」を許して入れる。
 */
export const GODOT_ANDROID_APK_URL = '/godot-android/Synchro.apk';

/** その試合を選んだ状態で開く URL（Godot の入口の `?game=<game_uuid>`） */
export const godotAppUrl = (gameUuid) => (gameUuid ? `${GODOT_APP_URL}?game=${encodeURIComponent(gameUuid)}` : GODOT_APP_URL);

/**
 * ドキュメントタイトルを組み立てる。**区別に効くものから順に**並べる
 * （タブは幅が狭いと後ろが「…」で切られるので、先頭ほど残る）。
 *
 *   pageTitle('デュエル')            → 'デュエル | DuelSim'
 *   pageTitle('第3試合', 'デュエル')  → '第3試合 - デュエル | DuelSim'
 *   pageTitle(null)                  → 'DuelSim'
 */
export function pageTitle(...parts) {
  const named = parts.filter((p) => typeof p === 'string' && p.trim()).map((p) => p.trim());
  return named.length ? `${named.join(' - ')} | ${APP_NAME}` : APP_NAME;
}

/**
 * ページごとのタイトルを付ける。**すべてのページで呼ぶこと**
 * （呼ばないと前のページのタイトルが残る。appInfo.test.js が漏れを見張る）。
 *
 * 名前がまだ読めていないうちは null を渡してよい。読めた時点で付け直す。
 */
export function usePageTitle(...parts) {
  const title = pageTitle(...parts);
  useEffect(() => { document.title = title; }, [title]);
}
